import React from 'react';
import Box from '@mui/material/Box';

type InputStateProps = {
  status?: boolean | null;
};

export const InputState: React.FC<InputStateProps> = ({ status = false }) => (
  <Box
    className="input-state"
    sx={{ backgroundColor: status ? '#00B191' : ' #9a9ba2', borderRadius: '50%' }}
    height={14}
    width={14}
  />
);
